/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Shape, Vector2 } from "three";
import { cache } from "../../cache";
const makePoly = (sides) => {
    const poly = [];
    for (let idx = 0, l = sides + 2; idx <= l; idx++) {
        const a = ((idx - 0.5) * Math.PI * 2) / sides;
        const an = a + Math.PI / sides;
        poly.push({ x: Math.sin(a), y: Math.cos(a), nx: Math.sin(an), ny: Math.cos(an) });
    }
    return poly;
};
// Question: where did this code come from? Seems like due for an update to make it more readable
const rshape = (edges, radius, 
//
lx, ly, 
//
nx, ny) => {
    const points = [];
    // Why?
    const rx = radius * 0.5;
    const ry = radius * 0.5;
    for (let idx = 0, l = edges.length - 2; idx < l; idx++) {
        const r = edges[idx]; // Current
        const r1 = edges[idx + 1]; // Next
        let dx = 0;
        let dy = 0;
        let out = false;
        let out1 = true;
        if (r.nx * nx + r.ny * ny < 0) {
            dx = lx;
            dy = ly;
            out = true;
        }
        if (r1.nx * nx + r1.ny * ny >= 0) {
            out1 = false;
        }
        let rdx = dx + r.x * rx;
        let rdy = dy + r.y * ry;
        let rdx1 = dx + r1.x * rx;
        let rdy1 = dy + r1.y * ry;
        points.push({ x: rdx, y: rdy });
        if (out !== out1) {
            rdx = lx + r1.x * rx;
            rdy = ly + r1.y * ry;
            rdx1 = r1.x * rx;
            rdy1 = r1.y * ry;
            points.push({ x: rdx1, y: rdy1 });
        }
    }
    return points;
};
export function createCircleOrOblongShape(size, position, angle, resolution = 64, rotationCenter, scale) {
    return cache(() => {
        // Added clamp to prevent negative values - seems the right thing to do
        const width = Math.max(0, size.x);
        const height = Math.max(0, size.y);
        const square = Math.min(width, height);
        const rangeX = width > height ? width - height : 0;
        const rangeY = width > height ? 0 : height - width;
        const center = new Vector2(-0.5 * rangeX, -0.5 * rangeY);
        const pivot = new Vector2(rotationCenter?.x ?? position?.x ?? 0, rotationCenter?.y ?? position?.y ?? 0);
        const points = rshape(makePoly(resolution), 
        //
        square, 
        //
        rangeX, rangeY, 
        //
        center.x, center.y).map((coord) => {
            const point = new Vector2(coord.x, coord.y);
            point.add(center);
            point.multiply(new Vector2(scale?.x ?? 1, scale?.y ?? 1));
            point.add(new Vector2(position?.x ?? 0, position?.y ?? 0));
            point.rotateAround(pivot, angle ?? 0);
            return point;
        });
        // Question: how important is it to return shape as a THREE Shape now? Probably
        // sufficient to return an ordered array of points. If call sites need a Shape,
        // they can call Shape.setFromPoints()
        return new Shape().setFromPoints(points);
    }, "createCircleOrOblongShape", [size, position, angle, resolution, scale]);
}
//# sourceMappingURL=createCircleOrOblongShape.js.map